import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

@Component({
    selector: 'app-common-address',
    templateUrl: './common-address.component.html',
    styleUrls: ['./common-address.component.css'],
    standalone: false
})
export class CommonAddressComponent implements OnInit {
  @Input() title;
  @Input() editableCityStateZip: boolean;
  editCityStateZip: boolean;
  billofladingAddressForm: UntypedFormGroup;
  constructor(private formBuilder: UntypedFormBuilder) { }

  ngOnInit() {
    this.editCityStateZip = this.editableCityStateZip;
    this.createbillofladingAddressForm();
  }

  createbillofladingAddressForm() {
    this.billofladingAddressForm = this.formBuilder.group({
      line1: new UntypedFormControl('', Validators.required),
      line2: new UntypedFormControl(''),
      city: new UntypedFormControl('', Validators.required),
      state: new UntypedFormControl(''),
      zip: new UntypedFormControl(''),
      phone: new UntypedFormControl(''),
      altPhone: new UntypedFormControl(''),
      email: new UntypedFormControl('')
      // otherContactInfo: new FormControl('')
    });
  }

}
